export default __webpack_public_path__ + "static/media/logo.f50e0bf0.svg";